import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/feed");
    else setErr(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 grain bg-[#0a0a0a]">
      <div className="w-full max-w-md fade-up">
        <Link to="/" className="inline-flex items-center gap-3 mb-10" data-testid="back-home">
          <span className="w-8 h-8 rounded-full border border-[#d4af37]/70 flex items-center justify-center">
            <span className="text-[#d4af37] font-serif">L</span>
          </span>
          <span className="font-serif text-xl tracking-wider">Lumière Club</span>
        </Link>

        <p className="text-[#d4af37] text-xs uppercase tracking-[0.3em] mb-3">Members</p>
        <h1 className="font-serif text-4xl sm:text-5xl leading-tight">Welcome back.</h1>
        <p className="text-white/50 mt-3 mb-10">Enter your credentials to continue.</p>

        <form onSubmit={submit} className="space-y-8" data-testid="login-form">
          <div>
            <label className="text-[10px] uppercase tracking-[0.25em] text-white/40">Email</label>
            <input
              type="email"
              className="editorial-input mt-2"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email"
              placeholder="you@example.com"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.25em] text-white/40">Password</label>
            <input
              type="password"
              className="editorial-input mt-2"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </div>

          {err && (
            <p className="text-sm text-red-400" data-testid="login-error">
              {err}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#d4af37] text-black py-4 uppercase tracking-[0.2em] text-sm font-medium hover:bg-[#f3e5ab] transition disabled:opacity-50"
            data-testid="login-submit"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>

          <p className="text-center text-sm text-white/50">
            Not a member yet?{" "}
            <Link to="/apply" className="text-[#d4af37] hover:text-[#f3e5ab]" data-testid="link-apply">
              Apply for membership →
            </Link>
          </p>

          <p className="text-center text-xs text-white/30">
            <Link to="/forgot-password" className="hover:text-[#d4af37] tracking-wider uppercase" data-testid="link-forgot-password">
              Forgot password?
            </Link>
          </p>
        </form>

        <div className="mt-10 pt-6 border-t border-white/10 text-center flex justify-center gap-6">
          <Link
            to="/privacy"
            className="text-[10px] uppercase tracking-[0.25em] text-white/30 hover:text-[#d4af37] transition"
            data-testid="login-privacy-link"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            className="text-[10px] uppercase tracking-[0.25em] text-white/30 hover:text-[#d4af37] transition"
            data-testid="login-terms-link"
          >
            Terms
          </Link>
        </div>
      </div>
    </div>
  );
}
